import React from "react";
import { showActiveTravelZonesAtom } from "./analysisAtoms";
import { SwitchControl } from "./SwitchControl";
export const TravelZoneSwitchControl = () => {
    return (
        <SwitchControl
            atom={showActiveTravelZonesAtom}
            label="Show active travel zones"
            name="travelZones"
        />
    );
};
